// Routes for the eK Score Configuration screen, which holds the Questionnaire, Seasons, Climate,
// Heavy rain, MSP prices and Crop names configuration, the reference data Coverage check, and bulk
// re-scoring, under one sidebar entry. Kept apart from the page so the screens it hosts can link
// back to it without importing the page that imports them.
export const EK_SCORE_CONFIG_PATH = '/ekScoreConfiguration';

export const EK_SCORE_TABS = [
    { key: 'questionnaire', label: 'Questionnaire' },
    { key: 'seasons', label: 'Seasons' },
    { key: 'climate', label: 'Climate' },
    { key: 'heavyRain', label: 'Heavy rain' },
    { key: 'msp', label: 'MSP prices' },
    { key: 'cropNames', label: 'Crop names' },
    { key: 'coverage', label: 'Coverage' },
    { key: 'rescore', label: 'Re-score' },
];

export const ekScoreTabPath = (key) => `${EK_SCORE_CONFIG_PATH}/${key}`;

export const questionnaireVersionPath = (version) => `${ekScoreTabPath('questionnaire')}/${version}`;
